<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('credit analysis evaluations')"
      :columns="columns"
      :column_search="true"
      resource_url="/credit-analysis/evaluation/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("new evaluation") }}</span>
        </button>
        <!-- <button class="button is-info is-rounded" @click="refresh">
                  <span class="icon"><i class="fa fa-sync"></i></span>
                  <span>{{ $t("refresh") }}</span>
                </button>
                <button
                  class="button is-success is-rounded"
                  @click="exportResults"
                >
                  <span class="icon"><i class="fa fa-download"></i></span>
                  <span>{{ $t("export results") }}</span>
                </button> -->
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";

import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  success_message,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisEvaluationsDatatable",
  components: {
    GenericTable,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: this.$t("customer"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return `<div class="title is-5">${row.customer_name || ""}</div>
                    <div class="subtitle is-6">
                      <span class="icon">
                        <i class="fa fa-id-card"></i>
                      </span>
                      <span>
                        <strong>${v.$t("dpi")}: </strong> ${row.dpi || ""}
                      </span>
                    </div>`;
          },
        },
        {
          title: this.$t("other info"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            let segment = "";
            if (row.settings && row.settings.segment) {
              segment = `<div class="subtitle is-6"><span class="icon"><i class="fa fa-tags"></i></span><span>
                <strong>${v.$t("segment")}: </strong> ${v.$t(
                row.settings.segment || "unset"
              )}
              </span></div>`;
            }
            return `<div class="subtitle is-6 mb-1"><span class="icon"><i class="fa fa-file-text"></i></span><span>
              <strong>${v.$t("pagare")}: </strong> ${row.pagare_number || ""}
            </span></div>
            <div class="subtitle is-6 mb-1"><span class="icon"><i class="fa fa-id-card"></i></span><span>
              <strong>${v.$t("nit")}: </strong> ${row.nit || ""}
            </span></div>${segment}`;
          },
        },
        // {
        //   title: this.$t("evaluation result"),
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => {
        //     const resultClass = this.getResultClass(row.final_result);
        //     return `<span class="tag ${resultClass}">${v.$t(
        //       row.final_result
        //     )}</span>`;
        //   },
        // },
        // {
        //   title: this.$t("score"),
        //   name: "score",
        //   searchable: false,
        //   width: "8%",
        //   data: (row) => row.score || "",
        // },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "10%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);
            const resultClass = this.getResultClass(row.final_result);
            // return `<span class="tag ${statusClass}">${this.$t(
            //   row.status || "draft"
            // )}</span>`;
            return `<div class="field is-grouped is-grouped-multiline">                      
                      <div class="control">
                        <div class="tags has-addons">
                          <span class="tag is-dark">${v.$t("result")}</span>
                          <span class="tag ${resultClass}">${v.$t(
              row.final_result || "unset"
            )}</span>
                        </div>
                      </div>
                    </div>`;
          },
        },
        // {
        //   title: this.$t("evaluation date"),
        //   name: "create_date",
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => moment(row.create_date).format("DD/MM/YYYY"),
        // },
        {
          title: this.$t("actions"),
          searchable: false,
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  v.$emit("view", row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("evaluate"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);
                  post("/credit-analysis/evaluation/start", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("approve"),
                icon: "fa fa-check",
                icon_class: "is-small has-text-success",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);
                  post("/credit-analysis/evaluation/approve", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("reject"),
                icon: "fa fa-times",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);
                  post("/credit-analysis/evaluation/reject", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("comment"),
                icon: "fa fa-comment",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  v.$emit("comment", row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete credit analysis evaluation?"),
                    v,
                    () => {
                      v.$root.loader(true);
                      del("/credit-analysis/evaluation", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        })
                        .finally(() => {
                          v.$root.loader(false);
                        });
                    }
                  );
                },
              },
              //   {
              //     args: { uuid: row.uuid },
              //     tooltip: v.$t("edit"),
              //     icon: "fa fa-edit",
              //     icon_class: "is-small has-text-warning",
              //     click: (e) => {
              //       v.$refs.modal.open(row.uuid);
              //     },
              //   },
            ];

            return generate_datatables_buttons(btns);
          },
          // generate_datatables_buttons(
          //   row,
          //   this.edit,
          //   this.delete,
          //   this.view,
          //   [
          //     {
          //       title: this.$t("upload pdf"),
          //       icon: "fa fa-upload",
          //       class: "is-warning",
          //       action: this.uploadPdf,
          //       condition: !row.pdf_file_path,
          //     },
          //     {
          //       title: this.$t("complete evaluation"),
          //       icon: "fa fa-check-circle",
          //       class: "is-success",
          //       action: this.completeEvaluation,
          //       condition: row.status === "draft",
          //     },
          //   ]
          // ),
        },
      ],
    };
  },
  methods: {
    create() {
      // Check if there's a request_uuid in route query
      // const request_uuid = this.$route.query.request_uuid;
      // this.$refs.modal.open(null, request_uuid);
      this.$emit("create");
    },
    edit(row) {
      this.$emit("edit", { uuid: row.uuid });
      // this.$refs.modal.open(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(() => {
        del("/credit-analysis/evaluation", { uuid: row.uuid })
          .then(() => {
            success_message(this.$t("evaluation deleted successfully"));
            this.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    uploadPdf(row) {
      // this.$refs.modal.open(row.uuid, null, "upload");
      this.$emit("uploadPdf", { uuid: row.uuid });
    },
    completeEvaluation(row) {
      // Quick complete evaluation
      this.$emit("complete", { uuid: row.uuid });
      // this.$refs.modal.open(row.uuid, null, "complete");
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    exportResults() {
      const url = "/credit-analysis/evaluation/export?format=csv";
      window.open(url, "_blank");
      success_message(this.$t("export started"));
    },
    getResultClass(result) {
      if (result == "unevaluated") return "is-warning";
      else if (result == "rejected") return "is-danger";
      else if (result == "approved") return "is-success";
      else return "";
      //     return "is-danger";
      //   } else {
      //     return "is-success";
      //   }
      // } else return "";
    },
    getResultText(result) {
      if (Array.isArray(result)) {
        let failed = result.find((x) => {
          return x.rules.find((rule) => rule.result.check === false);
        });
        if (failed) {
          return this.$t("rejected");
        } else {
          return this.$t("passed");
        }
      } else return "";
    },
    getStatusClass(status) {
      const classes = {
        draft: "is-dark",
        completed: "is-success",
        archived: "is-dark",
      };
      return classes[status] || "is-dark";
    },
    getRuleIcon(rule) {
      if (rule.result.check === true)
        return '<span class="icon has-text-info"><i class="fa fa-check"></i></span>';
      else if (rule.result.check === false)
        return '<span class="icon has-text-danger"><i class="fa fa-times"></i></span>';
      else
        return '<span class="icon has-text-warning"><i class="fa fa-exclamation-triangle"></i></span>';
    },
  },
  created() {},
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
/* Specific styles for evaluations datatable */
</style>
